import React from 'react';
import { StyledImage } from '@/components/MobileApproval/Content/styles';
import { imgUrlChk } from '@/utils/function';

type P = {
  docId: string;
  profiles: string[];
};

const MAX_SHOW_PROFILE = 4;

const ProfilesImages = ({ docId, profiles }: P) => {
  const invitedCount = profiles.length;
  return (
    <div style={{ position: 'relative', display: 'flex', maxWidth: '85px' }}>
      {profiles.map((url, idx) => {
        // 5명 이상일 때: 처음 3개 프로필 + "..." 표시
        if (invitedCount && invitedCount > MAX_SHOW_PROFILE + 1) {
          if (idx < MAX_SHOW_PROFILE) {
            return (
              <StyledImage
                style={{
                  position: 'relative',
                  left: idx > 0 ? `${-18 * idx}px` : '0px',
                  zIndex: idx,
                }}
                key={`${docId}-${url}-${idx}`}
                src={url ? imgUrlChk(url) : '/images/dummy/default-profile.svg'}
                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                  e.currentTarget.src = '/images/dummy/default-profile.svg';
                }}
              />
            );
          } else if (idx === MAX_SHOW_PROFILE) {
            return (
              <div
                key={`${docId}-more-${idx}`}
                style={{
                  display: 'flex',
                  backgroundColor: 'var(--dk-bg-strong, #E7E9EC)',
                  color: 'var(--dk-text-strong, #5F636B)',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  position: 'relative',
                  left: `${-18 * idx}px`,
                  zIndex: idx,
                  width: '24px',
                  height: '24px',
                  minWidth: '24px',
                  border: '1px solid var(--dk-bg, white)',
                  fontSize: '12px',
                  fontWeight: 400,
                  lineHeight: '18px',
                }}
              >
                {`+${
                  profiles.length - MAX_SHOW_PROFILE > 9
                    ? 9
                    : profiles.length - MAX_SHOW_PROFILE
                }`}
              </div>
            );
          }
          return null;
        } else {
          if (idx < MAX_SHOW_PROFILE + 1) {
            return (
              <StyledImage
                style={{
                  position: 'relative',
                  left: idx > 0 ? `${-18 * idx}px` : '0px',
                  zIndex: idx,
                }}
                key={`${docId}-${url}-${idx}`}
                src={url ? imgUrlChk(url) : '/images/dummy/default-profile.svg'}
                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                  e.currentTarget.src = '/images/dummy/default-profile.svg';
                }}
              />
            );
          }
          return null;
        }
      })}
    </div>
  );
};

export default ProfilesImages;
